import * as i0 from '@angular/core';
import { ViewContainerRef, Directive, Inject, Input, NgModule } from '@angular/core';

class TuiForDirective {
    constructor(vcr) {
        this.vcr = vcr;
        this.ngForOf = [];
    }
    ngOnChanges() {
        var _a, _b;
        (_a = this.ref) === null || _a === void 0 ? void 0 : _a.destroy();
        if (((_b = this.ngForOf) === null || _b === void 0 ? void 0 : _b.length) === 0 && this.ngForEmpty) {
            this.ref = this.vcr.createEmbeddedView(this.ngForEmpty);
        }
        else if (!this.ngForOf && this.ngForElse) {
            this.ref = this.vcr.createEmbeddedView(this.ngForElse);
        }
    }
}
TuiForDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiForDirective, deps: [{ token: ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive });
TuiForDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: TuiForDirective, selector: "[ngFor][ngForOf][ngForElse],[ngFor][ngForOf][ngForEmpty]", inputs: { ngForOf: "ngForOf", ngForElse: "ngForElse", ngForEmpty: "ngForEmpty" }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiForDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ngFor][ngForOf][ngForElse],[ngFor][ngForOf][ngForEmpty]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef, decorators: [{
                    type: Inject,
                    args: [ViewContainerRef]
                }] }]; }, propDecorators: { ngForOf: [{
                type: Input
            }], ngForElse: [{
                type: Input
            }], ngForEmpty: [{
                type: Input
            }] } });

class TuiForModule {
}
TuiForModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiForModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TuiForModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiForModule, declarations: [TuiForDirective], exports: [TuiForDirective] });
TuiForModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiForModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiForModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TuiForDirective],
                    exports: [TuiForDirective],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TuiForDirective, TuiForModule };
